import * as React from 'react';
import { cn } from '../../../ui';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../../ui';

const URGENCY_COLOR = {
  1: 'var(--green)',
  2: 'var(--aqua)',
  3: 'var(--yellow)',
  4: 'var(--orange-warn)',
  5: 'var(--red-critical)',
};

const URGENCY_LABEL = {
  1: 'Info',
  2: 'Low',
  3: 'Medium',
  4: 'High',
  5: 'Critical',
};

function UrgencyIndicator({ urgency = 1, className }) {
  const level = Math.max(1, Math.min(5, urgency));

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('inline-flex items-center gap-0.5 shrink-0', className)}>
          {[1, 2, 3, 4, 5].map((i) => (
            <span
              key={i}
              className="inline-block rounded-full"
              style={{
                width: 5,
                height: 5,
                backgroundColor: i <= level ? URGENCY_COLOR[level] : 'var(--surface)',
              }}
            />
          ))}
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        Urgency: {level}/5 — {URGENCY_LABEL[level]}
      </TooltipContent>
    </Tooltip>
  );
}

export { UrgencyIndicator };
